export default __webpack_public_path__ + "static/media/icon-impression.bf9da9ef.svg";